import { useAuth } from "@/utils/useAuth";
import axios from "axios";
import { toast } from "react-toastify";

interface IProps {
  contractId: string;
  resource?: any; // Mantido para compatibilidade, mas não será usado na nova implementação
}

/**
 * Função para cancelar uma assinatura ou atualizar um contrato
 * @param param0 Objeto contendo o ID do contrato e opcionalmente o recurso
 * @returns Resposta da API
 */
export async function PutContract({ contractId, resource }: IProps) {
  const apiUrl = `${import.meta.env.VITE_ENDPOINT_BILLING}/subscription`;

  try {
    const response = await axios.post(`${apiUrl}/unsubscribe`, {
      contractId: `${contractId}`,
    }, {
      headers: {
        'Authorization': await useAuth.getUserToken()
      }
    });

    return {
      data: response.data,
      status: response.status,
    };
  } catch (error) {
    if (axios.isAxiosError(error)) {
      console.error("Erro ao cancelar assinatura:", error.message);
      if (error.response) {
        console.error("Detalhes do erro:", error.response.data);
      }
      toast.error(
        `Erro ao cancelar assinatura: ${
          error.response?.status || "Falha na conexão"
        }`
      );
    } else {
      console.error("Ocorreu um erro desconhecido:", error);
      toast.error("Ocorreu um erro desconhecido ao cancelar assinatura");
    }
    throw new Error("Falha ao cancelar assinatura");
  }
}
